import { useTranslation } from 'react-i18next';
import Container from '@/components/ui/Container';
import SectionHeading from '@/components/ui/SectionHeading';
import FAQItem from './FAQItem';
import { useInView } from '@/hooks/useInView';

const faqKeys = ['isFree', 'shareQR', 'secure', 'updateInfo', 'noApp'] as const;

export default function FAQ() {
  const { t } = useTranslation();
  const { ref, isInView } = useInView(0.1);

  const faqs = faqKeys.map((key) => ({
    question: t(`faq.items.${key}.question`),
    answer: t(`faq.items.${key}.answer`),
  }));

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <Container>
        <SectionHeading
          title={t('faq.title')}
          subtitle={t('faq.subtitle')}
        />

        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-8 transition-all duration-700 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {faqs.map((faq, index) => (
            <FAQItem key={faqKeys[index]} {...faq} />
          ))}
        </div>
      </Container>
    </section>
  );
}
